import Vue from 'vue'
import App from './App.vue'
import * as echarts from 'echarts';
import router from './router'  // 引入路由配置

Vue.config.productionTip = false
Vue.prototype.$echarts = echarts

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
